import { createFileRoute } from '@tanstack/react-router'
import { Box, Stack, styled, Typography } from '@mui/material'
import { FEATURES, isFeatureEnabled } from '@/utils/feature-flag'
import { redirect } from '@tanstack/react-router'
import { PageSitesFilter } from '@/components/PageSitesFilter/PageSitesFilter.tsx'
import { DashboardGrid } from '@/features/fleet/components/layout/DashboardGrid.tsx'
import { useTranslation } from 'react-i18next'

const DashboardSubTitleTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(18),
  fontWeight: 400
}))

export const Route = createFileRoute('/_authenticated/$companySlug/dashboard/')({
  beforeLoad: ({ context }) => {
    // Check if dashboard feature is enabled
    if (!isFeatureEnabled(FEATURES.DASHBOARD)) {
      throw redirect({ to: '/not-found' })
    }
    // TODO improve this with a specific permission to access dashboard
    context.auth.rejectIfMissingPermissions(['SITE_READ'])
  },
  component: RouteComponent
})

function RouteComponent() {
  const { t } = useTranslation('_routes')
  const { sites: filterSites } = Route.useSearch()
  const { auth } = Route.useRouteContext()

  return (
    <Stack spacing={4}>
      <Box
        sx={{
          mb: 4,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start'
        }}
      >
        <Box sx={{ mr: 5 }}>
          <Typography variant="h1" color="primary">
            {t('routes.dashboard.components.DashboardTitle.title', {
              name: auth.user.firstName
            })}
          </Typography>
          <DashboardSubTitleTypography color="primary">
            {t('routes.dashboard.components.DashboardTitle.subtitle')}
          </DashboardSubTitleTypography>
        </Box>
        <PageSitesFilter />
      </Box>

      <DashboardGrid siteIds={filterSites} />
    </Stack>
  )
}
